import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { post } from '../../util/api';
import { parseContactFile } from '../../util/contacts';
import { Card, PageHead, SearchInput, Tag, Stat, Empty, Loading, Pager, Btn, COLORS, num, paginate, searchMatch, downloadSheets, notify } from './ui';

class Tables extends Component {
	constructor(props) {
		super(props);
		this.currentPage = 1;
		this.cellsPerPage = 100;
	}

	state = {
		loading: true,
		saveButton: 'add',
		ex_file: '',
		isAddUserModalOpen: false,
		list: [],
		numberList: [],
		selectedExcel: null,
		deleteButtonLoading: false,
		deleteModal: false,
		loadingBtn: false,
		message: false,
		openDeleteModal: false,
		currentPage: 1,
	};

	openAddUserModal = () => {
		this.setState({ isAddUserModalOpen: true });
	};

	closeAddUserModal = () => {
		this.setState({ isAddUserModalOpen: false, openDeleteModal: false, selectedUserId: '', openEditModal: false });
	};

	componentDidMount() {
		this.getTagList();
		this.getList();
	}
	handlePageChange = (newPage, list) => {
		const totalPages = Math.ceil(list.length / this.cellsPerPage);
		if (newPage >= 1 && newPage <= totalPages) {
			//this.currentPage = newPage;
			this.setState({ currentPage: newPage });
			//this.getList();
		}
	};

	async getList() {
		const { product } = this.props;
		let pid = product.id;
		await post('/broadcast/listBroadcastUser', { pid, state: 'unsubcribe' }).then((data) => {
			let list = data.data.result;
			console.log('loading', list);
			this.setState({
				list,
				filtered_list: list,
				selectedUserId: '',
				loading: false,
				isAddUserModalOpen: false,
				openDeleteModal: false,
				loadingBtn: false,
				openEditModal: false,
				name: '',
				phone: '',
				selectedUser: '',
				selectedUserId: '',
			});
		});
	}
	async getTagList() {
		await post('/dahi/tag/list').then((data) => {
			let result = data.data && data.data.result && data.data.result.result;
			this.setState({ tagList: _.filter(result, { active: true }) });
		});
	}
	async addUser() {
		const { product } = this.props;
		let pid = product.id;
		let { name, phone, tag } = this.state;
		let body = {
			pid,
			name,
			phone,
			data: { tag },
		};
		await post('/broadcast/createBroadcastUserList', body);
		this.getList();
	}

	async addUserExcel(data) {
		const { product } = this.props;
		let pid = product.id;
		let users = _.map(data, (it) => ({
			name: it.Name,
			phone: it.Phone,
			data: { tag: it.Label },
		}));
		let body = {
			pid,
			users,
		};
		await post('/broadcast/createBroadcastUserListExcel', body);
		this.getList();
	}
	async deleteUser() {
		const { product } = this.props;
		let pid = product.id;
		let { selectedUserId } = this.state;
		let body = { pid, id: selectedUserId };
		await post('/broadcast/deleteBroadcastUser', body);
		this.getList();
	}
	async updateUser() {
		const { product } = this.props;
		let pid = product.id;
		let { selectedUser } = this.state;
		let body = {
			pid,
			id: selectedUser.id,
			user: selectedUser,
		};
		await post('/broadcast/updateBroadcastUser', body);
		this.getList();
	}

	fileUpload(file) {
		this.setState({ loadingBtn: true });
		parseContactFile(file)
			.then(async (data) => {
				if (data && data.success) await this.addUserExcel(data.rows);
				this.setState({ loadingBtn: false });
			})
			.catch(() => this.setState({ loadingBtn: false }));
	}

	handleFileInput = (e) => {
		let file = e.target.files[0];
		this.fileUpload(file);
	};

	downloadExample = async () => {
		var a = document.createElement('a');
		a.href = '/contacts_example.xlsx';
		a.target = '_blank';
		a.download = 'contacts_example.xlsx';
		a.click();
	};
	handleSearch = async (e, { value }) => {
		let regex = new RegExp(value);
		let list = this.state.list;
		console.log('regex', regex, list);
		let filtered_list = value ? _.filter(list, (it) => regex.test(it.name.toLocaleLowerCase('tr')) || regex.test(it.phone)) : list;
		this.setState({ filtered_list });
	};
	render() {
		const { t, product } = this.props;
		let { loading, list, q, currentPage } = this.state;
		if (loading) return <Loading />;
		list = list || [];
		let rows = _.filter(list, (it) => searchMatch(q, it.name, it.phone));
		return (
			<div>
				<PageHead
					title={t('unsublist')}
					desc={t('Listeden çıkan kişiler. Bu numaralara toplu gönderim yapılmaz.')}
					right={
						<Btn
							variant="ghost"
							icon="download"
							disabled={!list.length}
							onClick={() =>
								downloadSheets('unsub_' + product.id + '_' + Date.now(), [
									{
										name: 'unsub',
										x: ['Name', 'Phone', 'Label'],
										datasets: _.map(list, (it) => ({ Name: it.name || '', Phone: it.phone || '', Label: ((it.data && it.data.tag) || []).join(',') })),
									},
								]).catch(() => notify(t('Dışa aktarılamadı.'), 'err'))
							}
						>
							{t('Dışa aktar')}
						</Btn>
					}
				/>
				<div className="wsm-stats">
					<Stat label={t('Listeden çıkan')} value={num(list.length)} color={COLORS.danger} />
				</div>
				<Card>
					<div className="wsm-section">
						<SearchInput value={q} onChange={(v) => this.setState({ q: v, currentPage: 1 })} placeholder={t('İsim veya numara ara…')} />
					</div>
					{!list.length ? (
						<Empty compact icon="userX" title={t('Listeden çıkan kişi yok')} />
					) : (
						<>
							<div className="wsm-table-wrap">
								<table className="wsm-table" style={{ minWidth: 520 }}>
									<thead>
										<tr>
											<th style={{ width: 60 }}>#</th>
											<th>{t('name')}</th>
											<th>{t('phone')}</th>
											<th>{t('label')}</th>
										</tr>
									</thead>
									<tbody>
										{paginate(rows, currentPage, this.cellsPerPage).map((it, index) => (
											<tr key={it.id || index}>
												<td className="wsm-faint">{(currentPage - 1) * this.cellsPerPage + index + 1}</td>
												<td style={{ fontWeight: 500 }}>{it.name || <span className="wsm-faint">—</span>}</td>
												<td className="wsm-muted wsm-nowrap">{it.phone}</td>
												<td>
													{it.data && it.data.tag && _.compact(it.data.tag).length ? (
														<div className="wsm-tags">
															{_.compact(it.data.tag).map((tg) => (
																<Tag key={tg}>{tg}</Tag>
															))}
														</div>
													) : (
														<span className="wsm-faint">—</span>
													)}
												</td>
											</tr>
										))}
										{!rows.length ? (
											<tr>
												<td colSpan={4} className="wsm-empty-row">
													{t('Aramanızla eşleşen kayıt bulunamadı.')}
												</td>
											</tr>
										) : null}
									</tbody>
								</table>
							</div>
							<Pager page={currentPage} pageSize={this.cellsPerPage} total={rows.length} onChange={(p) => this.setState({ currentPage: p })} label={`${num(rows.length)} ${t('kişi')}`} />
						</>
					)}
				</Card>
			</div>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Tables));
